module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBold.37da9eec.woff2";